/**
 * Maximum number of CSV rows the contact importer accepts.
 * The validate grid renders an input per cell (not virtualized), so very large
 * files would choke the browser. Raise this cap only after adding virtualization.
 */
export const MAX_IMPORT_ROWS = 5000

/**
 * Subcategory slug for the default "Other / Other" company type. Imported
 * companies that don't match an existing First Bite company are created under
 * this type. Matched against the seeded company-category data; keep in sync with
 * the backend ("other-other" sub_category slug).
 */
export const DEFAULT_COMPANY_SUBCATEGORY_SLUG = 'other-other'

// The only contact field keys supported by this wizard. Mirrors HeaderMapping
// values in server/importengine/service/v2/data_ingest.py:54-63 plus company_name.
export const CONTACT_IMPORT_FIELD_KEYS = [
  'company_name',
  'contact_full_name',
  'contact_first_name',
  'contact_last_name',
  'contact_title',
  'contact_phone',
  'contact_work_email',
  'contact_personal_email',
  'contact_generic_email',
  'contact_linkedin_url',
  'contact_label',
] as const

const TEMPLATE_HEADERS = [
  'Company Name',
  'First Name',
  'Last Name',
  'Title',
  'Work Email',
  'Personal Email',
  'Phone',
  'LinkedIn URL',
  'Label',
]

/**
 * Triggers a browser download of a blank CSV template pre-populated with the
 * expected contact import column headers. Useful for users who need a starting
 * point before uploading their own data.
 */
export function downloadContactImportTemplate(): void {
  const csv = TEMPLATE_HEADERS.join(',') + '\n'
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'contacts_import_template.csv'
  a.click()
  window.URL.revokeObjectURL(url)
  a.remove()
}
